import { CDK_ROW_TEMPLATE, CdkFooterRow, CdkFooterRowDef } from '@angular/cdk/table';
import { ChangeDetectionStrategy, Component, Directive, HostBinding, Input, ViewEncapsulation } from '@angular/core';

/**
 * Footer row definition for the table.
 * Captures the footer row's template and other footer properties such as the columns to display.
 */
@Directive({
  selector: '[nFooterRowDef]',
  providers: [{ provide: CdkFooterRowDef, useExisting: NFooterRowDefDirective }],
})
export class NFooterRowDefDirective extends CdkFooterRowDef {
  @Input('nFooterRowDef') override columns: Iterable<string>;
  @Input('nFooterRowDefSticky') override sticky: boolean;
}

/** Footer template container that contains the cell outlet. Adds the right class and role. */
@Component({
  selector: 'n-footer-row, tr[n-footer-row]',
  template: CDK_ROW_TEMPLATE,
  // See note on CdkTable for explanation on why this uses the default change detection strategy.
  // tslint:disable-next-line:validate-decorators
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.None,
  exportAs: 'matFooterRow',
  providers: [{ provide: CdkFooterRow, useExisting: NFooterRowComponent }],
})
export class NFooterRowComponent extends CdkFooterRow {
  @HostBinding('attr.class') class = 'n-footer-row';
  @HostBinding('attr.role') role = 'row';
}
